import axios from "axios";
import firebase from "./firebase";

export const getLetterTemplates = async () => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/templates/letter`, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    });
    return data;
  } catch (error) {
    return null;
  }
};

export const createLetterTemplate = async ({ name, content }) => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_HOST}/templates/letter`,
      { name, content },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    );
    return data;
  } catch (error) {
    return null;
  }
};
